export const NavigationEnum = Object.freeze({
    BILLING_DETAILS: "BILLING_DETAILS",
    CONFIRMATION: "CONFIRMATION",
    RECIPIENT: "RECIPIENT",
    REVIEW: "REVIEW",
    SELECT_OPTION: "SELECT_OPTION",
    SENDER: "SENDER",
});
